import apiCall from '../AuthorizedApi';
import type {
  ListLeadsParams,
  PaginatedLeads,
  LeadDetail,
  LeadActivity,
  LeadStats,
  BulkStageUpdatePayload,
  BulkStageUpdateResponse,
  WhatsAppIntakeResponse,
  CreateLeadPayload,
  UpdateLeadPayload,
  UpdateStagePayload,
  PaginatedActivities,
  TriggerFollowUpResponse,
  PauseFollowUpResponse,
} from '../../../Data/leads.dto';

const BASE = '/api/v1/leads';

const buildQuery = (params: Record<string, any> = {}): string => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, String(v));
  });
  const s = q.toString();
  return s ? `?${s}` : '';
};

export const listLeadsAPI = (params?: ListLeadsParams): Promise<PaginatedLeads> =>
  apiCall({ method: 'GET', url: `${BASE}/${buildQuery(params as any)}` });

export const createLeadAPI = (data: CreateLeadPayload): Promise<LeadDetail> =>
  apiCall({ method: 'POST', url: `${BASE}/`, data });

export const getLeadStatsAPI = (): Promise<LeadStats> =>
  apiCall({ method: 'GET', url: `${BASE}/stats/` });

export const bulkStageUpdateAPI = (
  payload: BulkStageUpdatePayload
): Promise<BulkStageUpdateResponse> =>
  apiCall({ method: 'POST', url: `${BASE}/bulk-stage/`, data: payload });

export const getWhatsAppIntakeAPI = (
  customerNumber: string
): Promise<WhatsAppIntakeResponse> =>
  apiCall({
    method: 'GET',
    url: `${BASE}/whatsapp-intake/?customer_number=${encodeURIComponent(customerNumber)}`,
  });

export const getLeadDetailAPI = (id: string): Promise<LeadDetail> =>
  apiCall({ method: 'GET', url: `${BASE}/${id}/` });

export const updateLeadAPI = (id: string, data: UpdateLeadPayload): Promise<LeadDetail> =>
  apiCall({ method: 'PATCH', url: `${BASE}/${id}/`, data });

export const deleteLeadAPI = (id: string): Promise<void> =>
  apiCall({ method: 'DELETE', url: `${BASE}/${id}/` });

export const updateLeadStageAPI = (
  id: string,
  payload: UpdateStagePayload
): Promise<LeadDetail> =>
  apiCall({ method: 'PATCH', url: `${BASE}/${id}/stage/`, data: payload });

export const markLeadLostAPI = (id: string, reason: string): Promise<LeadDetail> =>
  apiCall({ method: 'POST', url: `${BASE}/${id}/mark-lost/`, data: { reason } });

export const triggerFollowUpAPI = (id: string): Promise<TriggerFollowUpResponse> =>
  apiCall({ method: 'POST', url: `${BASE}/${id}/trigger-follow-up/` });

export const pauseFollowUpAPI = (id: string): Promise<PauseFollowUpResponse> =>
  apiCall({ method: 'POST', url: `${BASE}/${id}/pause-follow-up/` });

export const listLeadActivitiesAPI = (
  id: string,
  page: number = 1
): Promise<PaginatedActivities> =>
  apiCall({ method: 'GET', url: `${BASE}/${id}/activities/?page=${page}` });

export const logLeadNoteAPI = (id: string, note: string): Promise<LeadActivity> =>
  apiCall({ method: 'POST', url: `${BASE}/${id}/log-note/`, data: { note } });
